export * from './agregar-insumo-dialog.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/agris-detalle-insumo-page/agregar-insumo-dialog/index.ts